import { alpha } from '@mui/material';
import { palette } from '@client/theme/colors';
import type { ThemeOptions } from '@mui/material';

const AppBar: ThemeOptions['components'] = {
  MuiAppBar: {
    defaultProps: {
      elevation: 0,
      color: 'inherit',
    },
    styleOverrides: {
      root: {
        '& > .MuiToolbar-root': {
          width: '100%',
        },
      },
      colorInherit: {
        backgroundColor: palette.grey[50],
      },
      colorDefault: {
        backgroundColor: palette.info.main,
      },
      colorTransparent: {
        backgroundColor: alpha(palette.grey[50], 0),
      },
    },
  },
};

export default AppBar;
